import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import TableReportHelper from "report/helper";
import acsHeaderReport from "./ACSHeaderReport";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import apontamentoColetasLocalizacaoReport from "entity/Indicador/reports/ApontamentoColetasLocalizacaoReport";
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport";

export default async function acsReport(indicador, visita) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type)

        content.push([
            await apontamentoHeaderLocalizacaoReport(visita, indicador, apontamento, params),

            await apontamentoColetasLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                ["Qtd. Canas Avaliadas", "Canas Secas e Doentes", "Canas Secas e Doentes (%)"],
                // prettier-ignore
                (h) => [
                    h.textField("avaliados"),
                    h.textField("secasDoentes"),
                    h.numberField("secasDoentesPercentual"),
                ],
                [100, 80, 60]
            ),

            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            h.space(),
        ]);
    }

    return content;
}
